// extracted by mini-css-extract-plugin
export default {"overlay":"PH-z","bodyOpen":"QH-z","content":"RH-z","header":"SH-z","close":"TH-z","closeNoHeading":"UH-z"};